import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Translator from 'translator';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { withTheme, Grid } from '@material-ui/core';
import { FHEContainerForm, FHEItemText, FHEDivider } from 'data/components';

class SDM18MVRDetail extends PureComponent {
    static propTypes = {
        theme: PropTypes.object.isRequired,
        planningMode: PropTypes.string,
        moduleType: PropTypes.string,
        code: PropTypes.string,
        lineType: PropTypes.string,
        planningSynched: PropTypes.number,
        value: PropTypes.string,
        label: PropTypes.string,
        planningType: PropTypes.string,
        favorite: PropTypes.number,
        calibrated: PropTypes.string
    };

    static defaultProps = {
        planningMode: null,
        moduleType: null,
        code: null,
        lineType: null,
        planningSynched: null,
        value: null,
        label: null,
        planningType: null,
        favorite: null,
        calibrated: null
    };

    render() {
        const { planningMode, moduleType, code, lineType, planningSynched, value, label, planningType, favorite, calibrated, theme } = this.props;
        return (
            <FHEContainerForm>
                <Grid container spacing={3}>
                    <FHEDivider color={theme.palette.colors.grey100} />
                    <Grid container item sm={12} md={6} lg={4}>
                        <FHEItemText itemTitle={Translator.translate('general.table.column.label')} itemContent={label} />
                    </Grid>
                    <Grid container item sm={12} md={6} lg={4}>
                        <FHEItemText
                            itemTitle={Translator.translate('general.table.column.moduleType')}
                            itemContent={Translator.translate(`general.productModules.${moduleType}`)}
                        />
                    </Grid>
                    <Grid container item sm={12} md={6} lg={4}>
                        <FHEItemText
                            itemTitle={Translator.translate('general.table.column.lineType')}
                            itemContent={Translator.translate(`general.productModules.${lineType}`)}
                        />
                    </Grid>
                    <Grid container item sm={12} md={6} lg={4}>
                        <FHEItemText
                            itemTitle={Translator.translate('general.table.column.calibrated')}
                            itemContent={Translator.translate(`general.productModules.${calibrated}`)}
                        />
                    </Grid>
                    <FHEDivider color={theme.palette.colors.grey100} />
                    <Grid container item sm={12} md={6} lg={4}>
                        <FHEItemText
                            itemTitle={Translator.translate('general.table.column.planningMode')}
                            itemContent={Translator.translate(`general.productModules.${planningMode}`)}
                        />
                    </Grid>
                    <Grid container item sm={12} md={6} lg={4}>
                        <FHEItemText
                            itemTitle={Translator.translate('general.table.column.planningSynched')}
                            itemContent={Translator.translate(`general.productModules.${planningSynched}`)}
                        />
                    </Grid>
                    <Grid container item sm={12} md={6} lg={4}>
                        <FHEItemText
                            itemTitle={Translator.translate('general.table.column.planningType')}
                            itemContent={Translator.translate(`general.productModules.${planningType}`)}
                        />
                    </Grid>
                    <FHEDivider color={theme.palette.colors.grey100} />
                    <Grid container item sm={12} md={6} lg={4}>
                        <FHEItemText itemTitle={Translator.translate('general.table.column.code')} itemContent={code} />
                    </Grid>
                    <Grid container item sm={12} md={6} lg={4}>
                        <FHEItemText itemTitle={Translator.translate('general.table.column.value')} itemContent={value} />
                    </Grid>
                    <Grid container item sm={12} md={6} lg={4}>
                        <FHEItemText
                            itemTitle={Translator.translate('general.table.column.favorite')}
                            itemContent={Translator.translate(`general.productModules.${favorite}`)}
                        />
                    </Grid>
                </Grid>
            </FHEContainerForm>
        );
    }
}

function mapStateToProps(state, props) {
    const productKey = props.productKey;
    let productModule = new Map();
    if (state.environments.fhe.data.Products.getIn(['list', productKey, 'productModules'])) {
        productModule = state.environments.fhe.data.Products.getIn(['list', productKey, 'productModules'], new Map()).first();
    }
    return {
        planningMode: productModule.get('planningMode'),
        moduleType: productModule.get('moduleType'),
        code: productModule.get('code'),
        lineType: productModule.get('lineType'),
        planningSynched: productModule.get('planningSynched'),
        value: productModule.get('value'),
        label: productModule.get('label'),
        planningType: productModule.get('planningType'),
        favorite: productModule.get('favorite'),
        calibrated: productModule.get('calibrated')
    };
}

export default withRouter(connect(mapStateToProps)(withTheme(SDM18MVRDetail)));



// WEBPACK FOOTER //
// ./environments/fhe/scenes/Products/components/Product/Fhe/SDM18MVR/index.js